import { filters, FilterSchema } from '@adc/blueprint'
import * as graph from '@adc/sdk'

const { FilterBuilder, FilterGroupBuilder } = filters.builders

const statusFilterDefinition = new FilterGroupBuilder('status', 'Status')
  .description('Filter by status')
  .items([
    new FilterBuilder('is_active', 'multiSelect', 'string')
      .options<'multiSelect'>([
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' },
      ])
      .styleIntent({ controlVariant: 'inline-radio' })
      .build(),
  ])
  .build()

const typesFilterDefinition = new FilterGroupBuilder('types', 'Types')
  .description('Filter by organization type')
  .items([
    new FilterBuilder('types', 'multiSelect', 'string')
      .options<'multiSelect'>(
        filters.utils.deriveOptionsList(graph.enums.OrganizationType)
      )
      .styleIntent({ controlVariant: 'inline-radio' })
      .build(),
  ])
  .build()

// Organizations index stores `groups` as OrganizationGroup objects, so the
// group_type lives at `groups.group_type`.
const orgGroupFilterDefinition = new FilterGroupBuilder('groups', 'Groups')
  .description('Filter by group')
  .items([
    new FilterBuilder('groups.group_type', 'multiSelect', 'string')
      .label('Groups')
      .options<'multiSelect'>(
        filters.utils.deriveOptionsList(graph.enums.OrganizationGroupType)
      )
      .styleIntent({ controlVariant: 'inline-radio' })
      .build(),
  ])
  .build()

// OrganizationMember index stores `groups` as a flat array of
// OrganizationGroupType strings — filter on `groups` directly, not a subfield.
const memberGroupFilterDefinition = new FilterGroupBuilder('groups', 'Groups')
  .description('Filter by group')
  .items([
    new FilterBuilder('groups', 'multiSelect', 'string')
      .label('Groups')
      .options<'multiSelect'>(
        filters.utils.deriveOptionsList(graph.enums.OrganizationGroupType)
      )
      .styleIntent({ controlVariant: 'inline-radio' })
      .build(),
  ])
  .build()

// Filters that don't belong to a specific facet (status/types/groups/dates).
const otherFiltersDefinition = new FilterGroupBuilder('other', 'Other Filters')
  .description('Additional filters')
  .items([
    new FilterBuilder('is_trusted', 'multiSelect', 'string')
      .label('Trusted')
      .options<'multiSelect'>([
        { label: 'Trusted', value: 'true' },
        { label: 'Not Trusted', value: 'false' },
      ])
      .styleIntent({ controlVariant: 'inline-radio' })
      .build(),
  ])
  .build()

const dateFilterDefinition = new FilterGroupBuilder('dates', 'Dates')
  .description('Filter by dates')
  .items([
    new FilterBuilder('created_date', 'range', 'Date')
      .label('Created Date')
      .build(),
    new FilterBuilder('updated_date', 'range', 'Date')
      .label('Updated Date')
      .build(),
  ])
  .build()

// Organizations grid filters: status, types, groups (objects), dates, other.
export const definition: FilterSchema.FilterDefinitionGenerator<
  never // no config needed here
> = (): FilterSchema.FilterGroupDefinitionArray => {
  return [
    statusFilterDefinition,
    typesFilterDefinition,
    orgGroupFilterDefinition,
    dateFilterDefinition,
    otherFiltersDefinition,
  ]
}

// Members grid filters: status, groups (strings), dates. Members have no
// `types` field in the ORGANIZATION_MEMBERS index, so Types is omitted.
export const memberDefinition: FilterSchema.FilterDefinitionGenerator<
  never
> = (): FilterSchema.FilterGroupDefinitionArray => {
  return [
    statusFilterDefinition,
    memberGroupFilterDefinition,
    dateFilterDefinition,
  ]
}
